/*
 *  Main js
 *  @author: jd@cals.arizona.edu
 *  @lastModified: Oct 2018
 */
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import './registerServiceWorker';
// https://github.com/telerik/kendo-ui-npm-example/tree/master/typescript-webpack/core
import $ from "jquery";
import "kendo-ui-core"; // OPTIMIZE: don't import the whole thing, just what you need in each module (ex: import 'kendo-ui-core/js/kendo.ui')

import 'bootstrap/js/transition';
import 'bootstrap/js/collapse';
import 'bootstrap/js/tab';

import { onDomReady as appOnDomReady } from './scripts/lib/desertland.app';
import { onDocumentReady as cbOnDocReady } from './cb';

// $("#sel").kendoDropDownList(); // verified works

Vue.config.productionTip = false;

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');


// this verifies that jQuery is available...
$(document).ready(() => {
  // console.log("dom!");
  appOnDomReady();
  cbOnDocReady();
});// END dom ready


// console.log('%cDESERTLAND: %o',"color:green;font-weight:bold;",DESERTLAND);







// for ref if need to use in future
// //https://github.com/typekit/webfontloader

// WebFont.load({
//     google: {
//       families: ['Oswald:400,300,700:latin,latin-ext', 'Roboto+Condensed:400,300,700:latin,latin-ext']
//     },
//     loading: function() {log('WebFont.loading');},
// 	active: function() {log('WebFont.active');},
// 	inactive: function() {log('WebFont.inactive');},
// 	fontloading: function(familyName, fvd) {log('WebFont.fontloading',familyName);},
// 	fontactive: function(familyName, fvd) {log('WebFont.fontactive',familyName);},
// 	fontinactive: function(familyName, fvd) {log('WebFont.fontinactive',familyName);}
//  });


// ref:
//http://alfredobarron.github.io/smoke/#/panel
//http://alfredobarron.github.io/smoke/#/notifications
//http://alfredobarron.github.io/smoke/#/progressbar
